import { Col, Row } from "antd";
import { sortBy, values } from "lodash";
import React, { useEffect, useState } from "react";
import {
  CATEGORY_VO_BOC_GOI,
  KEY_OPTIONS,
  PROPERTY_TYPE,
  WIDTH_MOBILE,
} from "../../common/constant";
import { getBanners } from "../../shared/helpers";
import ProductAddToCart from "./productInformationAddToCart";
import ProductAttribute from "./productInformationAttribute";
import ProductGifts from "./productInformationGift";
import ProductPrice from "./productInformationPrice";
import "./style.scss";

const ProductInformation = (props: any) => {
  const {
    product,
    setProductCode,
    banners,
    setBanners,
    match,
    productCode,
    productFoam,
    productSpecCode,
  } = props;
  const [productInfo, setProductInfo] = useState<any>(
    product.size_prices.filter((s: any) => s.value === product.code)[0]
  );
  const [quantity, setQuantity] = useState(1);
  const [currentOption, setCurrentOption] = useState<any>(null);
  const [currentGift, setCurrentGift] = useState<any>(null);

  useEffect(() => {
    if (product) {
      setProductInfo(
        product.size_prices.filter((s: any) => s.value == product.code)[0]
      );
      setQuantity(1);

      getDefaultValue();
    }
  }, [product]);

  useEffect(() => {
    if (!currentOption) return;

    if (
      currentOption[PROPERTY_TYPE.type]
      // &&
      // _option[PROPERTY_TYPE.type] &&
      // currentOption[PROPERTY_TYPE.type].value !==
      // _option[PROPERTY_TYPE.type].value
    ) {
      const productNameDisplayEl = document.querySelector(
        "#product-detail-name"
      );

      if (productNameDisplayEl) {
        // console.log("option: ", _option[PROPERTY_TYPE.type]?.label);
        productNameDisplayEl.textContent =
          currentOption[PROPERTY_TYPE.type]?.label;
      }
    }

    const storageOption = JSON.parse(
      sessionStorage.getItem(KEY_OPTIONS) || "{}"
    );

    const _currentOption = JSON.stringify({
      ...storageOption,
      [match.params.pro_id]: currentOption,
    });
    sessionStorage.setItem(KEY_OPTIONS, _currentOption);
    handleChangeProductInfo(currentOption);
  }, [currentOption]);

  const checkNewFeatureCode = () => {
    if (product && product.props && product.props.length) {
      let _cover =
        product.props.find((p: any) => p.code === PROPERTY_TYPE.cover) || null;

      let _type =
        product.props.find((p: any) => p.code === PROPERTY_TYPE.type) || null;

      return (
        (_cover &&
          _cover.values &&
          _cover.values.length &&
          _cover.values[0].pf_prefix) ||
        (_type && _type.is_new_bed)
      );
    }
    return false;
  };

  const handleChangeOption = (option?: any) => {
    let _option = { ...option };

    if (
      _option[PROPERTY_TYPE.image] &&
      _option[PROPERTY_TYPE.image].code !== PROPERTY_TYPE.image
    ) {
      _option[PROPERTY_TYPE.image] = {
        ..._option[PROPERTY_TYPE.image],
        code: PROPERTY_TYPE.image,
      };
    }
    setCurrentOption(_option);
  };

  const getDefaultValue = () => {
    const options = JSON.parse(sessionStorage.getItem(KEY_OPTIONS) || "{}");
    let _option: any = {};

    if (productSpecCode || productFoam || !options) {
      product.props.map((p: any) => {
        _option[p.code] = {
          code: p.code,
          image:
            p.code === PROPERTY_TYPE.image
              ? p.values.find((item: any) => item.value === getValue(p))?.img
              : null,
          is_use: p.is_use,
          label: p.values.find((item: any) => item.value === getValue(p))
            ?.label,
          position: p.position,
          title: p.label,
          value: getValue(p),
        };
      });
    } else {
      if (options && options[match.params.pro_id]) {
        product.props.map((p: any) => {
          _option[p.code] = {
            code: p.code,
            image: options[match.params.pro_id][p.code]?.image || null,
            is_use: p.is_use,
            label: options[match.params.pro_id][p.code]?.label,
            position: p.position,
            title: p.label,
            value: options[match.params.pro_id][p.code]?.value,
          };
        });
      } else {
        product.props.map((p: any) => {
          _option[p.code] = {
            code: p.code,
            image:
              p.code === PROPERTY_TYPE.image
                ? p.values.find((item: any) => item.value === getValue(p))?.img
                : null,
            is_use: p.is_use,
            label: p.values.find((item: any) => item.value === getValue(p))
              ?.label,
            position: p.position,
            title: p.label,
            value: getValue(p),
          };
        });
      }
    }

    setCurrentOption(_option);
  };

  const getValue = (property: any) => {
    let value = property.default_value;

    if (productSpecCode) {
      if (property.code === PROPERTY_TYPE.type) {
        value = property.values.filter((v: any) => {
          if (v.patterns.indexOf(productSpecCode) !== -1) {
            return true;
          }
        })[0]?.value;
      }

      if (property.code === PROPERTY_TYPE.image) {
        value = productSpecCode;
      }
    }

    if (productFoam) {
      if (property.code === PROPERTY_TYPE.foam) {
        value = parseInt(productFoam || "1");
      }
    }

    return value;
  };

  const handleChangeProductInfo = (option: any) => {
    //change banner for drap
    if (option) {
      if (option[PROPERTY_TYPE.image]) {
        setBannersDrap(PROPERTY_TYPE.image, option[PROPERTY_TYPE.image].value);
      } else {
        // if (option[PROPERTY_TYPE.type]) {
        //   setBanners(
        //     innerWidth >= WIDTH_MOBILE
        //       ? getBanners(
        //           product.img_details[option[PROPERTY_TYPE.type].value]
        //         )
        //       : product.img_details_web_screen_mobile &&
        //         product.img_details_web_screen_mobile[
        //           option[PROPERTY_TYPE.type].value
        //         ] &&
        //         product.img_details_web_screen_mobile[
        //           option[PROPERTY_TYPE.type].value
        //         ].length
        //       ? getBanners(
        //           product.img_details_web_screen_mobile[
        //             option[PROPERTY_TYPE.type].value
        //           ]
        //         )
        //       : getBanners(
        //           product.img_details[option[PROPERTY_TYPE.type].value]
        //         )
        //   );
        // } else {
        setBanners(
          innerWidth >= WIDTH_MOBILE
            ? getBanners(product.img_details[product.parent_id])
            : product.img_details_web_screen_mobile &&
              product.img_details_web_screen_mobile[product.parent_id] &&
              product.img_details_web_screen_mobile[product.parent_id].length
            ? getBanners(
                product.img_details_web_screen_mobile[product.parent_id]
              )
            : getBanners(product.img_details[product.parent_id])
        );
        // }
      }
    }

    // change price
    const _options = values(sortBy(option, ["position"]));

    const code = _options.reduce((prev, curr) => {
      let _prev = prev || "";
      if (curr.is_use) {
        _prev += curr.value;
      }
      return _prev;
    }, "");

    const checkPrice = product.size_prices.find((v: any) => {
      if (checkNewFeatureCode() || product.cat_id == CATEGORY_VO_BOC_GOI) {
        return v.value === code;
      } else {
        return v.value.includes(code);
      }
    });

    if (checkPrice && checkPrice.value != productCode) {
      const queryFoam = productFoam ? `?foam=${productFoam}` : "";

      if (!productCode && match.url[match.url.length - 1] != "/") {
        props.history.replace(
          match.params.pro_id + "/" + checkPrice.value + queryFoam
        );
      } else {
        props.history.replace(checkPrice.value + queryFoam);
      }

      setProductInfo(checkPrice);
      setProductCode(checkPrice.value);
    }
  };

  const setBannersDrap = (key: any, value: any) => {
    const temp = product.props
      .filter((f: any) => f.code === key)
      .map((p: any) => ({
        code: p.code,
        title: p.label,
        value: value,
        label: p.values.find((item: any) => item.value === value),
        is_use: p.is_use,
        position: p.position,
      }));

    if (
      temp &&
      temp[0].label?.imgs_slide_detail &&
      temp[0].label?.imgs_slide_detail?.length
    ) {
      setBanners(getBanners(temp[0].label?.imgs_slide_detail));
    } else {
      setBanners(
        innerWidth >= WIDTH_MOBILE
          ? getBanners(product.img_details[product.parent_id])
          : product.img_details_web_screen_mobile &&
            product.img_details_web_screen_mobile[product.parent_id] &&
            product.img_details_web_screen_mobile[product.parent_id].length
          ? getBanners(product.img_details_web_screen_mobile[product.parent_id])
          : getBanners(product.img_details[product.parent_id])
      );
    }
  };

  const handleChangeGift = (gift: any) => {
    setCurrentGift(gift);
  };

  return (
    <Row align="top" justify="center">
      <Col span={24} className="product-information-container">
        <ProductPrice
          productCatId={product.product_cat_id}
          productInfo={productInfo}
        />
        {currentOption && (
          <ProductAttribute
            {...props}
            handleChangeProductInfo={handleChangeProductInfo}
            productDetail={product}
            productCatId={product.product_cat_id}
            productInfo={productInfo}
            quantity={quantity}
            setQuantity={setQuantity}
            banners={banners}
            setBanners={setBanners}
            currentOption={currentOption}
            handleChangeOption={handleChangeOption}
          />
        )}
        <ProductAddToCart
          {...props}
          product={product}
          productInfo={productInfo}
          currentOption={currentOption}
          currentGift={currentGift}
          quantity={quantity}
        />
        <ProductGifts
          product={product}
          productInfo={productInfo}
          quantity={quantity}
          currentGift={currentGift}
          handleChangeGift={handleChangeGift}
        />
      </Col>
    </Row>
  );
};

export default ProductInformation;
